
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorGeneralClosedLeft as ObiTwowayAcuatorGeneralClosedLeftElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-general-closed-left.js';
 
 
 

 
 export const ObiTwowayAcuatorGeneralClosedLeft = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-general-closed-left',
   elementClass: ObiTwowayAcuatorGeneralClosedLeftElement,
   events: {
     
   }
  });
 
 